export default angular.module('mars.vet.dnareports.services.chart',[]).factory('ChartService', function() {
   'ngInject';
    return {
        printRow: function(row) {
            //console.log("printRow(): row length: " + row.length);
            angular.forEach(row, function(column, key) {
                //console.log("column/row length: " + column.length);
                angular.forEach(column, function(value, key) {
                    console.log("column value: " + value['breed'] + ' ' + value['confFlag'] + ' ' + value['confPC']);
                });
            });
        },
        getDisplayName: function(breedList) {
            //console.log('length: ' + breedList.length);
            var displayName = '';

            var mixed = false;
            angular.forEach(breedList, function(value, key) {
                //console.log("breed: " + value['displayName']);
                if (value['displayName'] != 'Mixed Breed') {
                    displayName += key > 0 ? ' / ' + value['displayName'] : value['displayName'];
                } else {
                    mixed = true;
                }
            });
            if (mixed === true && breedList.length == 1) {
                displayName = 'Mixed Breed';
            } else if (mixed === true) {
                displayName += ' Mix';
            } else if (breedList.length > 1) {
                displayName += ' Cross';
            }
            //  console.log('displayName: ' + displayName+displayName.indexOf('/'));
            if (displayName.indexOf('/') == 1) {
                //console.log('am here'+displayName.length);
                displayName = displayName.substring(2, displayName.length);
            }
            return displayName;
        }
    };
}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/services/chart.service.js